import { Controller } from "stimulus";


export default class extends Controller {
  static get targets() {
    return ["syncableInput", "inputToSync"];
  }

  syncableInputTargetConnected() {
    this.syncableInputTargets.forEach((syncableInput) => {
      syncableInput.addEventListener("change", this.sync.bind(this));
      syncableInput.addEventListener("keyup", this.sync.bind(this));
    });

    this.sync();
  }

  sync() {
    this.syncableInputTargets.forEach((syncableInput) => {
      let inputToSync = this.inputToSyncTargets.find((input) => input.id === syncableInput.id);

      inputToSync.value = syncableInput.value;
    });
  }
}
